import * as Sentry from '@sentry/react';
import { type Integration } from '@sentry/types';
import React from 'react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import runtime from './runtime';

const { sentry: sentryConfig } = runtime;

const integrations: Integration[] = [
    Sentry.reactRouterV6BrowserTracingIntegration({
        enableInp: true,
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
    }),
];

const sentryInitOptions: Sentry.BrowserOptions = {
    release: sentryConfig.release,
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
};

if (sentryConfig.tracing) {
    sentryInitOptions.tracesSampleRate = sentryConfig.tracesSampleRate;
}

if (sentryConfig.profiling) {
    sentryInitOptions.tracesSampleRate = sentryConfig.profilingSampleRate;
    sentryInitOptions.profilesSampleRate = sentryConfig.profilingSampleRate;
}

if (sentryConfig.replay) {
    integrations.push(
        Sentry.replayIntegration({
            networkDetailAllowUrls: [window.location.origin],
            maskAllInputs: true,
            maskAllText: false,
        })
    );

    sentryInitOptions.replaysSessionSampleRate = sentryConfig.replaySampleRate;
    sentryInitOptions.replaysOnErrorSampleRate = 1.0;
}

sentryInitOptions.integrations = integrations;

Sentry.init(sentryInitOptions);
